import {createAsyncThunk} from '@reduxjs/toolkit';
import apiInstance from '../../Apis/Axios';

const serviceName = "traffic-fine-service";

export const GetAllFineTypes = createAsyncThunk("trafficFinesSection/GetAllFineTypes",async (params, { dispatch, getState }) => {

    const response = await apiInstance.get(`${serviceName}/v1/types/get-all`).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});

export const GetGeofenceConfigSetting = createAsyncThunk("trafficFinesSection/GetGeofenceConfigSetting",async (params, { dispatch, getState }) => {

    const response = await apiInstance.get(`${serviceName}/v1/geofence-config/get`).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});

export const GetAllLocationsByUserAndByDates = createAsyncThunk('trafficFinesSection/getAllLocationsByUserAndByDates',
    async ({ body }) => {
        const response = await apiInstance
            .post(`${serviceName}/v1/get/locations`,body)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
        const { data, status } = response;
        return { data, status };
    });

export const GetAllFineByDates = createAsyncThunk('trafficFinesSection/getAllLocationsByUserAndByDates',
    async ({ params,body }) => {
        const response = await apiInstance
            .post(`${serviceName}/v1/get-all/from/${params.from}/to/${params.to}`,body)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
        const { data, status } = response;
        return { data, status };
    });

export const CreateFine = createAsyncThunk("trafficFinesSection/CreateFine",async (params, { dispatch, getState }) => {

    const response = await apiInstance.post(`${serviceName}/v1/create`, params).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});

export const CreateEvidencesFine = createAsyncThunk("trafficFinesSection/CreateEvidencesFine",
    async (params, { dispatch, getState }) => {
    const response = await apiInstance.post(`${serviceName}/v1/evidences/create`, params, {
        headers: {
            "Content-Type": "multipart/form-data",
        }
    }).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});

